import { supabase } from './supabaseClient';

export const authFetch = async (url, options = {}) => {
  const { data: { session } } = await supabase.auth.getSession();
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...(session ? { Authorization: `Bearer ${session.access_token}` } : {}),
    },
  });
};
